<h1 class="pb-0" mat-dialog-title>
  {{ 'WEB-SIGN.SIGNTRUST-LIB.SIGNATURE-SETTING.TITLE' | translate }}
</h1>
<div mat-dialog-content class="">
  <div class="dialog-tab-content w-100">
    <div class="w-100 row m-0">
      <div class="col-12 col-lg-6 mb-2 px-1">
        <div class="p-2 b-rs-white">
          <div class="w-100">
            <mat-form-field class="w-100 fix-form-field-padding">
              <span class="d-inline-block fw-bolder pb-2">
                {{ 'WEB-SIGN.SIGN-IMG.LABELS.SIGN-CERT-INFO-CONFIG' | translate }}
              </span>
              <mat-select [attr.data-selenium]="'select-sign-details-type'" [(ngModel)]="metadataCertificate" (selectionChange)="detailsSignTypeChange($event.value)" required #signDetailsType>
                <mat-option [value]="true" [attr.data-selenium]="'option-default-img'">{{ 'WEB-SIGN.SIGN-IMG.LABELS.SIGN-METADATA-CONFIG' | translate }}</mat-option>
                <mat-option [value]="false" [attr.data-selenium]="'option-no-img'">{{ 'WEB-SIGN.SIGN-IMG.LABELS.SIGN-NO-METADATA-CONFIG' | translate }}</mat-option>
              </mat-select>
              <mat-hint class="text-danger animated fadeInDown" *ngIf="!(signDetailsType.selected)">{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint>
            </mat-form-field>
          </div>
          <div *ngIf="metadataCertificate" clas="w-100">
            <span class="d-inline-block fw-bolder pb-2">
              {{ 'WEB-SIGN.SIGN-IMG.LABELS.SELECT-METADATA-CONFIG' | translate }}
            </span>
            <div class="w-100">
              <div class="row m-0 p-3px b-rs-light">
                <div class="d-inline-block pe-2 float-start" *ngFor="let metadata of metadataSelection">
                  <mat-checkbox [disabled]="metadata.disabled" [readonly]="metadata.disabled" class="no-m-label" [(ngModel)]="metadata.check" (ngModelChange)="signDetailschage()">{{metadata.name}}</mat-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6 mb-2 px-1">
        <div class="p-2 b-rs-light">
          <div class="w-100">
            <mat-form-field class="w-100 fix-form-field-padding">
              <span class="d-inline-block fw-bolder pb-2">
                {{ 'WEB-SIGN.SIGN-IMG.LABELS.SELECT-SIGN-IMG-CONFIG' | translate }}
              </span>
              <mat-select
                [attr.data-selenium]="'select-sign-img-type'"
                [(ngModel)]="radioSignatureImage"
                (selectionChange)="visualSignTypeChange($event.value)"
                required
                #signImgType>
                <mat-option [value]="true" [attr.data-selenium]="'option-default-img'">
                  {{ 'WEB-SIGN.SIGN-IMG.LABELS.SIGN-PROFILE-IMG' | translate }}
                </mat-option>
                <mat-option [value]="false" [attr.data-selenium]="'option-no-img'">
                  {{ 'WEB-SIGN.SIGN-IMG.LABELS.SIGN-WITHOUT-IMG' | translate }}
                </mat-option>
              </mat-select>
              <mat-hint class="text-danger animated fadeInDown" *ngIf="!(signImgType.selected)">{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint>
            </mat-form-field>
          </div>

          <div class="w-100" *ngIf="radioSignatureImage">
            <div class="">
              <span class="d-inline-block fw-bolder pb-2">
                {{ 'WEB-SIGN.SIGN-IMG.LABELS.SIGN-IMG-CONFIG' | translate }}
              </span>
              <span class="d-inline-block line-none vertical-align-middle">
                <i class="rt-icon rt-info pointer ms-2" #tooltip="matTooltip" matTooltipPosition="below" [matTooltip]="'WEB-SIGN.SIGNTRUST-LIB.SIGNATURE-SETTING.LABELS.INFO' | translate " (click)="tooltip.show()"></i>
              </span>
            </div>
            <div class="w-100 row m-0">
              <div class="w-100">
                <div class="row w-100 animated fadeIn mx-0">
                  <div *ngIf="defaultImageFile" class="col-12 p-0">
                    <div class="drop-file">
                      <mat-card class="card-wrapper b-rs-white p-2">
                        <div
                          class="file pointer overTopContainer"
                          appDropFile
                          (onFileDropped)="onFileDropped($event)"
                          (click)="fileDropRef.click()">
                          <span class="cardContainerLeft">
                            <img
                              *ngIf="defaultImageFile | fileToBase64 | async as imgb64Src"
                              class="sign-img"
                              [src]="imgb64Src | domSanitizer: 'url'"
                              width="60"
                              alt="" />
                          </span>
                          <span class="cardContainerRight">
                            <!-- img info -->
                            <div class="w-100 d-inline-block text-start overflow-hidden text-ellipsis-1">
                                <span class="d-inline-block mb-0 fw-bold">{{ 'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.NAME' | translate }}: </span>
                                <small *ngIf="imgInfo?.name">
                                  {{imgInfo?.name}}
                                </small>
                                <span *ngIf="!imgInfo?.name">
                                  {{'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.NO-INFO' | translate}}
                                </span>
                            </div>
                            <div class="w-100 d-inline-block text-start overflow-hidden text-ellipsis-1">
                                <span class="d-inline-block mb-0 fw-bold">{{ 'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.SIZE' | translate }}: </span>
                                <small *ngIf="imgInfo?.size">
                                  {{imgInfo?.size}}
                                </small>
                                <span *ngIf="!imgInfo?.size">
                                  {{'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.NO-INFO' | translate}}
                                </span>
                            </div>
                          </span>
                          <button class="overTopButton primary" [matTooltip]="'NAVBAR.PAGES.SIGNATURE-SETTING.LABELS.CHANGE-IMAGE' | translate" matTooltipPosition="left" matTooltipTouchGestures="auto" mat-mini-fab aria-label="Replace file">
                            <i class="rt-icon rt-repeat fs25 color-all-light"></i>
                          </button>
                        </div>
                      </mat-card>
                    </div>
                  </div>
                </div>
                <div *ngIf="!defaultImageFile" class="row w-100 animated fadeIn mx-0">
                  <div class="col-12 p-0">
                    <div class="drop-file">
                      <div class="drop-area b-rs-white pointer" appDropFile (onFileDropped)="onFileDropped($event)" (click)="fileDropRef.click()">
                        <div class="d-flex justify-content-center align-items-center flex-row py-2">
                          <i class="rt-icon rt-portafirmas fs50 pe-2"></i>
                          <div class="drop-text">
                            <p class="drop-text-description m-0">{{ 'WEB-SIGN.IMG-UPLOAD.DESCRIPTION-3' | translate }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <input
                type="file"
                #fileDropRef
                id="fileDropRef"
                hidden="true"
                [accept]="allowedExtension.join(',')"
                (change)="onFileDropped($event.target.files[0]); $event.target.value = ''" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 row m-0">
      <div class="col-12 col-lg-6 mb-2 px-1" *ngIf="radioSignatureImage || metadataCertificate">
        <div class="p-2 b-rs-light">
          <div class="w-100">
            <mat-form-field class="w-100 fix-form-field-padding">
              <span class="d-inline-block fw-bolder pb-2">
                {{ 'WEB-SIGN.SIGN-IMG.LABELS.SIGN-PAGE-CONFIG' | translate }}
              </span>
              <mat-select [attr.data-selenium]="'select-sign-page-type'" [(ngModel)]="pageType" (selectionChange)="pagesSignTypeChange($event.value)" required #signDetailsType>
                <mat-option [value]="PageType.CURRENT" [attr.data-selenium]="'option-current-page'">{{ 'WEB-SIGN.SIGN-IMG.LABELS.CURRENT-PAGE' | translate }} <small class="text-secondary font-italic">({{ 'WEB-SIGN.SIGN-IMG.LABELS.PAGE' | translate }} {{ pageInfo?.currentPage }})</small></mat-option>

                <mat-option [value]="PageType.LAST" [attr.data-selenium]="'option-last-page'">{{ 'WEB-SIGN.SIGN-IMG.LABELS.LAST-PAGE' | translate }} <small class="text-secondary font-italic">({{ 'WEB-SIGN.SIGN-IMG.LABELS.PAGE' | translate }} {{pageInfo?.totalPages}})</small></mat-option>

                <mat-option [value]="PageType.ALL" [attr.data-selenium]="'option-all-pages'">{{ 'WEB-SIGN.SIGN-IMG.LABELS.ALL-PAGES' | translate }} <small class="text-secondary font-italic">({{ 'WEB-SIGN.SIGN-IMG.LABELS.PAGES' | translate }} 1-{{pageInfo?.totalPages}})</small></mat-option>

                <mat-option [value]="PageType.RANGE" [attr.data-selenium]="'option-range-pages'">{{ 'WEB-SIGN.SIGN-IMG.LABELS.PAGES-RANGE' | translate }} <small class="text-secondary font-italic">({{ 'WEB-SIGN.SIGN-IMG.LABELS.RANGE-PLACEHOLDER' | translate }})</small></mat-option>
              </mat-select>
              <mat-hint class="text-danger animated fadeInDown" *ngIf="!(signDetailsType.selected)">{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint>
            </mat-form-field>
          </div>
          <div class="w-100" *ngIf="pageType === PageType.RANGE">
            <span class="d-inline-block fw-bolder pb-2">
              {{ 'WEB-SIGN.SIGN-IMG.LABELS.PAGES-CUSTOM-RANGE' | translate }}
            </span>
            <mat-form-field class="w-100 fix-form-field-padding">
              <input
                #rangePages
                class=""
                matInput
                autocomplete="off"
                [(ngModel)]="pageRangeLabel"
                [required]="pageType === PageType.RANGE"
                (focus)="pageType = PageType.RANGE; initValidatePagesRange(pageRangeLabel)"
                (keyup)="initValidatePagesRange(pageRangeLabel)"
                [placeholder]="'WEB-SIGN.SIGN-IMG.LABELS.RANGE-PLACEHOLDER' | translate"/>
                <mat-hint class="text-danger animated fadeInDown" *ngIf="invalidRangeFormat">
                  <small class="vertical-top">
                    {{ 'WEB-SIGN.SIGNTRUST-LIB.ERRORS.INVALID-RANGE-FORMAT' | translate }}
                  </small>
                </mat-hint>
                <mat-hint class="text-danger animated fadeInDown" *ngIf="pageType === PageType.RANGE && invalidRangerequired && !invalidRangeFormat">
                  <small class="vertical-top">
                  {{ 'WEB-SIGN.SIGNTRUST-LIB.ERRORS.REQUIRED' | translate }}
                </small>
              </mat-hint>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6 mb-2 px-1">
        <div class="p-2 b-rs-white">
          <div class="w-100">
            <!-- certificate selection -->
            <mat-form-field class="w-100 fix-form-field-padding">
              <span class="d-inline-block fw-bolder pb-2">
                {{ 'WEB-SIGN.SIGN-IMG.LABELS.SELECTION-CERTIFICATE' | translate }}
              </span>
              <mat-select [attr.data-selenium]="'select-sign-details-type'" [(ngModel)]="selectCertificateType" (selectionChange)="certificateSignTypeChange($event.value)" required #signDetailsType>
                <mat-option [value]="true" [attr.data-selenium]="'option-default-img'">{{ 'WEB-SIGN.SIGN-IMG.LABELS.REMEMBER-CERTIFICATE' | translate }}</mat-option>
                <mat-option [value]="false" [attr.data-selenium]="'option-no-img'">{{ 'WEB-SIGN.SIGN-IMG.LABELS.ASK-CERTIFICATE' | translate }}</mat-option>
              </mat-select>
              <mat-hint class="text-danger animated fadeInDown" *ngIf="!(signDetailsType.selected)">{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint>
            </mat-form-field>
          </div>

          <div class="w-100" *ngIf="selectCertificateType">
            <span class="d-inline-block fw-bolder pb-2">
              {{ 'WEB-SIGN.SIGN-IMG.LABELS.SELECT-CERTIFICATE' | translate }}
            </span>
            <div class="w-100 b-rs-light p-2" *ngIf="!selectCertificate">
              <button mat-stroked-button class="w-100" (click)="onSelectCertificate()" color="primary">{{ 'WEB-SIGN.SIGN-IMG.LABELS.CERT-SELECT' | translate }}</button>
            </div>

            <div class="w-100 row m-0" *ngIf="selectCertificate">
              <div class="col-12 p-0">
                <div class="drop-file">
                  <mat-card class="card-wrapper b-rs-light p-2">
                    <div class="file pointer overTopContainer"
                      (click)="onSelectCertificate()">
                      <span class="cardContainerLeft">
                        <i class="rt-icon rt-certificate fs50"></i>
                      </span>

                      <span class="cardContainerRight">
                        <div class="w-100 d-inline-block text-start overflow-hidden text-ellipsis-1">
                          <span class="d-inline-block mb-0 fw-bold">{{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.ALIAS' | translate }} </span>
                          <small *ngIf="selectCertificate?.alias">
                            {{ selectCertificate?.alias }}
                          </small>
                          <span *ngIf="!selectCertificate?.alias">
                            {{'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.NO-INFO' | translate}}
                          </span>
                        </div>
                        <div class="w-100 d-inline-block text-start overflow-hidden text-ellipsis-1">
                          <span class="d-inline-block mb-0 fw-bold">{{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.EXPIRES' | translate }} </span>
                          <small *ngIf="selectCertificate?.expiration">
                            {{ selectCertificate?.expiration | dateMultiLang: 'currentLang':'small' }}
                          </small>
                          <span *ngIf="!selectCertificate?.expiration">
                            {{'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.NO-INFO' | translate}}
                          </span>
                        </div>
                      </span>
                      <button class="overTopButton primary" [matTooltip]="'GLOBAL.CHANGE' | translate" matTooltipPosition="left" matTooltipTouchGestures="auto" mat-mini-fab [aria-label]="'GLOBAL.CHANGE' | translate">
                        <i class="rt-icon rt-repeat fs25 color-all-light"></i>
                      </button>
                    </div>
                  </mat-card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w-100 b-rs-white p-2" *ngIf="metadataCertificate || (radioSignatureImage && defaultImageFile)">
      <div class="w-100">
        <span class="d-inline-block fw-bolder pb-2">
          {{ 'WEB-SIGN.SIGN-IMG.LABELS.SIGN-IMG-PREVIEW' | translate }}
        </span>
      </div>
      <div class="m-auto">
        <div id="imgTemplate" class="d-inline-block">
          <div class="template-content">
            <div class="p-0 img-template-content me-1" *ngIf="radioSignatureImage && defaultImageFile">
              <img *ngIf="defaultImageFile | fileToBase64 | async as imgb64Src" class="img-template" [src]="imgb64Src | domSanitizer: 'url'" alt="" />
            </div>
            <div class="p-0 metadata-template-content" *ngIf="metadataCertificate">
              <div *ngIf="metadataSelection[0].check">
                <span class="fw-bold">{{metadataSelection[0].name}}: </span>
                <span *ngIf="selectCertificate?.alias">{{selectCertificate?.alias}}</span>
                <span *ngIf="!selectCertificate?.alias">{{'WEB-SIGN.SIGN-IMG.LABELS.CERT-SUBJECT-EXAMPLE' | translate}}</span>
              </div>
              <div *ngIf="metadataSelection[1].check">
                <span class="fw-bold">{{metadataSelection[1].name}}: </span>
                <span>{{username}}</span>
              </div>
              <div *ngIf="metadataSelection[2].check">
                <span class="fw-bold">{{metadataSelection[2].name}}: </span>
                <span>{{currentDate | dateMultiLang:currentLang}}</span>
              </div>
              <div *ngIf="metadataSelection[3].check">
                <span class="fw-bold">{{metadataSelection[3].name}}: </span>
                <small *ngIf="selectCertificate?.thumbprint">{{selectCertificate?.thumbprint}}</small>
                <span *ngIf="!selectCertificate?.thumbprint">{{'WEB-SIGN.SIGN-IMG.LABELS.CERT-THUMBPRINT-EXAMPLE' | translate}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions class="w-100">

  <!-- SAVE -->
  <button mat-raised-button class="ms-2 float-end" color="primary" type="button" [attr.data-selenium]="'button-save'" [disabled]="blockImg || blockPages || blockCertificate || sendingInfo || !hasChanges" (click)="onCloseEditSign('SAVE')">
    <i class="rt-icon rt-disquete" *ngIf="isMobile"></i>
    <i class="fas fa-spinner fa-pulse fa-1x mr-1" *ngIf="sendingInfo"></i>
    <span *ngIf="!isMobile">{{ 'GLOBAL.SAVE-CONTINUE' | translate }}</span>
  </button>

  <!-- CONTINUE -->
  <button mat-stroked-button class="ms-2 float-end" color="primary" [attr.data-selenium]="'button-continue'" [disabled]="blockImg || blockPages || blockCertificate || sendingInfo || !hasChanges" (click)="onCloseEditSign('CONTINUE')">
    <i class="rt-icon rt-transporte" *ngIf="isMobile"></i>
    <span *ngIf="!isMobile">{{ 'GLOBAL.CONTINUE-UNSAVE' | translate }}</span>
  </button>

  <!-- CANCEL -->
  <div class="auto-spacer"></div>
  <button mat-stroked-button color="primary" class="" [attr.data-selenium]="'button-cancel'" [disabled]="sendingInfo" (click)="onCancel()">
    <i class="rt-icon rt-cerrar" *ngIf="isMobile"></i>
    <span *ngIf="!isMobile">{{ 'GLOBAL.CANCEL' | translate }}</span>
  </button>

</div>
